import { useState, useEffect } from 'react';
import { useLang } from '../../../hooks/use-lang';
import { Editor } from '@tiptap/react';

const textStyles: {
  key: string;
  name: string;
  fontWeight: number;
  fontSize: number;
  level?: number;
}[] = [
  { key: 'heading', name: 'Заголовок 1', fontWeight: 600, fontSize: 28, level: 1 },
  { key: 'heading', name: 'Заголовок 2', fontWeight: 500, fontSize: 24, level: 2 },
  { key: 'heading', name: 'Заголовок 3', fontWeight: 500, fontSize: 20, level: 3 },
  { key: 'paragraph', name: 'Обычный текст', fontWeight: 400, fontSize: 16 },
];

const colorStyle = [
  '#212529',
  '#845EF7',
  '#339AF0',
  '#22B8CF',
  '#51CF66',
  '#FCC419',
  '#FF6B6B',
  '#F06595',
  '#CED4DA',
  '#5F3DC4',
  '#1864AB',
  '#0B7285',
  '#2B8A3E',
  '#E67700',
  '#C92A2A',
  '#C2255C',
];

const alignStyles: string[] = ['left', 'center', 'right', 'justify'];

export const useToolbar = (editor: Editor | null) => {
  const { t } = useLang();

  const [color, setColor] = useState(colorStyle[0]);

  const selectedColor = editor?.getAttributes('textStyle');
  useEffect(() => {
    if (selectedColor) {
      setColor(selectedColor.color);
    }
  }, [selectedColor]);

  const [align, setAlign] = useState(alignStyles[0]);

  const selectedAlign = editor?.getAttributes('heading').textAlign;
  useEffect(() => {
    if (selectedAlign) {
      setAlign(selectedAlign);
    }
  }, [selectedAlign]);

  const [text, setText] = useState(textStyles[3].name);

  const selectedLevel = editor?.getAttributes('heading').level;
  useEffect(() => {
    if (selectedLevel) {
      setText(textStyles[selectedLevel - 1].name);
    } else {
      setText(textStyles[3].name);
    }
  }, [selectedLevel]);

  return {
    textStyles,
    colorStyle,
    text,
    setText,
    color,
    setColor,
    t,
    setAlign,
    align,
  };
};
